import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  Form,
  reduxForm,
} from 'redux-form';

import Button from '@material-ui/core/Button';
import FaceIcon from '@material-ui/icons/Face';
import BusinessIcon from '@material-ui/icons/Business';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import NavigationIcon from '@material-ui/icons/Navigation';
import LocalPostOfficeIcon from '@material-ui/icons/LocalPostOffice';
import MapIcon from '@material-ui/icons/Map';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';

import FormInput from '@components/FormInput/FormInput';
import TextArea from '@components/TextArea/TextArea';
import Select from '@components/Select/Select';
import Icon from '@components/Icon/Icon';

import {
  email,
  maxLength,
  phone,
  required,
} from '@utils/validators';

import './InquiryForm.scss';

const InquiryForm = ({
  countries,
  handleSubmit,
  isSubmitting,
}) => (
  <Form
    className="inquiry-form"
    onSubmit={handleSubmit}
  >
    <div className="inquiry-form__column">
      <div className="inquiry-form__row">
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <FaceIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <Field
              name="fullName"
              label="Full name *"
              component={FormInput}
              validate={[required]}
            />
          </div>
        </div>
      </div>
      <div className="inquiry-form__row">
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <BusinessIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <Field
              name="organization"
              label="Organization"
              component={FormInput}
            />
          </div>
        </div>
      </div>
      <div className="inquiry-form__row">
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <LocationOnIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <Field
              name="address.street"
              label="Address"
              component={FormInput}
            />
          </div>
        </div>
      </div>
      <div className="inquiry-form__row">
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <LocationCityIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <Field
              name="address.city"
              label="City"
              component={FormInput}
            />
          </div>
        </div>
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <NavigationIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <Field
              name="address.state"
              label="State/Province"
              component={FormInput}
            />
          </div>
        </div>
      </div>
      <div className="inquiry-form__row">
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <MapIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <div className="inquiry-form__country">
              <Field
                name="address.country"
                label="Country"
                placeholder="Country"
                className="inquiry-form__select"
                options={countries}
                component={Select}
              />
            </div>
          </div>
        </div>
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <LocalPostOfficeIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <Field
              name="address.postalcode"
              label="Postal code"
              component={FormInput}
              validate={[maxLength(10)]}
            />
          </div>
        </div>
      </div>
      <div className="inquiry-form__row">
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <EmailIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <div className="inquiry-form__country">
              <Field
                name="address.email"
                label="Email *"
                type="email"
                component={FormInput}
                validate={[required, email]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="inquiry-form__row">
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <PhoneIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <div className="inquiry-form__country">
              <Field
                name="address.phone"
                label="Telephone"
                component={FormInput}
                validate={[phone]}
              />
            </div>
          </div>
        </div>
        <div className="inquiry-form__group">
          <Icon className="inquiry-form__icon">
            <PermPhoneMsgIcon />
          </Icon>
          <div className="inquiry-form__input-wrapper">
            <div className="inquiry-form__country">
              <Field
                name="address.fax"
                label="Fax"
                component={FormInput}
                validate={[phone]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="inquiry-form__column">
      <div className="inquiry-form__row">
        <Field
          name="inquiry"
          label="Inquiry *"
          multiline
          className="inquiry-form__inquiry-text"
          rows="15"
          component={TextArea}
          validate={[required]}
        />
      </div>
      <div className="inquiry-form__row">
        <Button
          variant="contained"
          color="primary"
          type="submit"
          className="inquiry-form__button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </Button>
      </div>
    </div>
  </Form>
);

InquiryForm.propTypes = {
  countries: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'inquiry',
})(InquiryForm);



// WEBPACK FOOTER //
// ./src/routes/Case/Inquiry/components/InquiryForm.js